<div class="search-menu-toggle-restrictions">
  @for (restriction of searchContainer.restrictions; track $index) {
    <div>
      <mat-checkbox
        [(ngModel)]="restriction.on"
        (ngModelChange)="runSearch()"
      >
        <span class="search-menu-toggle-restrictions__text">
          {{ restriction.title | translate }}
        </span>
      </mat-checkbox>
    </div>
  }
</div>
